export * from './weak-map/is-weak-map.js';
